// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const addressInfoSelector = createSelector(
    (state): any => state,
    (res: { addressInfo: any }) => res.addressInfo
);

export const validatedAddressSelector = createSelector(
    addressInfoSelector,
    res => res.validatedAddress
);

export const wicAddressSelector = createSelector(
    addressInfoSelector,
    res => res.wicAddresses
);

export const wicSelectedAddressSelector = createSelector(
    addressInfoSelector,
    res => res.wicSelectedAddress
);
